export const API_URL = 'https://api.justcastit.com';
// export const API_URL = 'http://0.0.0.0:8848';
// export const API_URL = 'http://localhost:8848';

export default API_URL;
